import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { StockService } from '@stock/stock.service';
import { MotivoRechazo } from '@shared/enums/motivo-rechazo';

@Component({
  selector: 'app-modal-rechazos',
  templateUrl: './modal-rechazos.component.html'
})
export class ModalRechazosComponent {
  @Input() remito: any;
  cargandoRechazo = false;
  form: FormGroup;

  motivos = [
    { value: MotivoRechazo.CORTE_LUZ, label: 'Corte de luz / rotura de bomba en instalación' },
    { value: MotivoRechazo.DESPERFECTO_UNIDAD, label: 'Desperfecto de la unidad' },
    { value: MotivoRechazo.DESVIO_RUTEO, label: 'Desvío solicitado por ruteo' },
    { value: MotivoRechazo.FALTA_CAPACIDAD, label: 'Falta de capacidad' },
    { value: MotivoRechazo.OTROS, label: 'Otros' },
    { value: MotivoRechazo.PROBLEMAS_CLIMATICOS, label: 'Problemas climáticos / corte de ruta' },
    { value: MotivoRechazo.RECHAZO_INCOMPLETA, label: 'Rechazo cisterna incompleta - sin precinto' },
    { value: MotivoRechazo.RECHAZO_CALIDAD, label: 'Rechazo por calidad de producto' },
  ];

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private stockService: StockService
  ) {
    this.form = this.fb.group({
      motivo: [null, Validators.required],
      detalle: ['']
    });
  }

  cancelar(): void {
    this.activeModal.dismiss();
  }

  confirmar(): void {
    if (this.form.invalid) return;

    const payload = {
      recepcionId: this.remito?.id,
      motivoRechazo: Number(this.form.value.motivo),
      comentarioRechazo: this.form.value.detalle
    };

    this.cargandoRechazo = true;

    this.stockService.rechazarRecepcion(payload).subscribe({
      next: () => {
        this.cargandoRechazo = false;
        this.activeModal.close(payload);
      },
      error: () => (this.cargandoRechazo = false)
    });
  }
}
